import { Button, Group, Modal, Stack, Table, Text, Title } from "@mantine/core";
import type { IViewSettingsDetails } from "./viewSettingsSelectors";

/** Presentation only; usable for saved presets and an unsaved view snapshot. */
export function ViewSettingsDialog({ details, onClose }: { details: IViewSettingsDetails; onClose: () => void }) {
  const { name, description, byClass, items, componentColor, articleColor, roomColor, validation, roomPanelLabel } = details;

  return (
    <Modal opened onClose={onClose} title={`Innstillinger – ${name}`} centered size="xl">
      <Stack gap="lg">
        {description && <Text size="sm">{description}</Text>}
        <Stack gap="xs">
          <Title order={5}>{byClass ? "Synlige komponenter" : "Synlige fag"}</Title>
          {items.length > 0 ? (
            <Table>
              <Table.Thead><Table.Tr>
                <Table.Th>{byClass ? "Komponent" : "Fag"}</Table.Th>
                {byClass && <Table.Th>IFC-klasse</Table.Th>}
                {byClass && <Table.Th ta="right">Opasitet</Table.Th>}
              </Table.Tr></Table.Thead>
              <Table.Tbody>{items.map(({ key, label, opacityPercent }) => (
                <Table.Tr key={key}>
                  <Table.Td>{label}</Table.Td>
                  {byClass && <Table.Td style={{ overflowWrap: "anywhere" }}>{key}</Table.Td>}
                  {byClass && <Table.Td ta="right" style={{ whiteSpace: "nowrap" }}>{opacityPercent} %</Table.Td>}
                </Table.Tr>
              ))}</Table.Tbody>
            </Table>
          ) : <Text size="sm">Ingen valgt.</Text>}
          <Text size="xs" c="dimmed">Andre modellkomponenter skjules.</Text>
        </Stack>
        <Stack gap="xs">
          <Title order={5}>Fargelegging</Title>
          <Table><Table.Tbody>
            <Table.Tr><Table.Th>Komponenter</Table.Th><Table.Td>{componentColor}</Table.Td></Table.Tr>
            <Table.Tr><Table.Th>Artikler</Table.Th><Table.Td>{articleColor}</Table.Td></Table.Tr>
            <Table.Tr><Table.Th>Rom</Table.Th><Table.Td>{roomColor}</Table.Td></Table.Tr>
          </Table.Tbody></Table>
        </Stack>
        <Stack gap="xs">
          <Title order={5}>Validering og rompanel</Title>
          <Text size="sm">Romfane: {roomPanelLabel}</Text>
          <Text size="sm">Filter: {validation.occurrences.filterMode === "listType" ? "Liste" : "Ansvar"}</Text>
          <Text size="sm">Liste: {validation.occurrences.listType ?? "Alle"} · Ansvar: {validation.occurrences.responsibility ?? "Alle"}</Text>
          <Text size="sm">Standardrom: {(validation.standardRoom.discipline ? `RI${validation.standardRoom.discipline}` : null) ?? "Automatisk"}</Text>
          <Text size="sm">Artikler: søk «{validation.occurrences.tableFilter.search || "—"}», {validation.occurrences.tableFilter.onlyDeviations ? "bare avvik" : "alle rader"}</Text>
          <Text size="sm">Standardrom: søk «{validation.standardRoom.tableFilter.search || "—"}», {validation.standardRoom.tableFilter.onlyDeviations ? "bare avvik" : "alle rader"}</Text>
        </Stack>
        <Text size="sm" c="dimmed">Etasje, kamera og valgt rom beholdes når du velger visningen.</Text>
        <Group justify="flex-end"><Button variant="neutral" onClick={onClose}>Lukk</Button></Group>
      </Stack>
    </Modal>
  );
}
